import React from 'react';
import Cookies from 'js-cookie';
import axios from 'axios';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';

import { useModal } from './Modal/ModalContext';

import Loading from './Loading';

import styles from '../styles/DynamicModal.module.css';
import stylesSearch from '../styles/Search.module.css';

const SearchUsers = ({ closeModal, type }) => {
    const { openModal } = useModal();
    const [users, setUsers] = React.useState([]);
    const [loading, setLoading] = React.useState(false);
    const [warning, setWarning] = React.useState('');

    React.useEffect(() => {
        document.body.style.overflow = 'hidden';
    
        return () => {
          document.body.style.overflow = '';
        };
    }, []);

    const handleLogout = () => {
        localStorage.removeItem('token');
        window.location.href = '/';
    }

    const [searchTerm, setSearchTerm] = React.useState('');

    React.useEffect(() => {
        const token = localStorage.getItem('token');

        if (token) {
            if (searchTerm !== '') {
                axios.get(`/api/search-users?searchterm=${searchTerm}&type=${type}`, {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    }
                })
                .then((response) => {
                    if (response.data.length === 0) {
                        setUsers([]);
                        setWarning('Пользователей не найдено.');
                    } else {
                        setUsers(response.data);
                        setWarning('');
                    }
                })
                .catch(error => {
                    console.error('Ошибка получения данных '+error);
                    setWarning(`Ошибка получения данных:  ${error.response?.data.message || error.message}`);
                })
                .finally(() => {
                    setLoading(false);
                })
            }
        } else {
            handleLogout();
        }
    }, [searchTerm])


    return (
        <div className={styles.liningOver} onClick={closeModal}>
            <form className={styles.lining} onClick={(e) => e.stopPropagation()}>
                <div className={styles.header}>
                    <h1>Поиск по пользователям</h1>
                    <svg onClick={closeModal} viewBox="0 0 24 24" fill="none">
                        <path fillRule="evenodd" clipRule="evenodd" d="M5.29289 5.29289C5.68342 4.90237 6.31658 4.90237 6.70711 5.29289L12 10.5858L17.2929 5.29289C17.6834 4.90237 18.3166 4.90237 18.7071 5.29289C19.0976 5.68342 19.0976 6.31658 18.7071 6.70711L13.4142 12L18.7071 17.2929C19.0976 17.6834 19.0976 18.3166 18.7071 18.7071C18.3166 19.0976 17.6834 19.0976 17.2929 18.7071L12 13.4142L6.70711 18.7071C6.31658 19.0976 5.68342 19.0976 5.29289 18.7071C4.90237 18.3166 4.90237 17.6834 5.29289 17.2929L10.5858 12L5.29289 6.70711C4.90237 6.31658 4.90237 5.68342 5.29289 5.29289Z" fill="#000000"/>
                    </svg>
                </div>
                <div className={styles.main}>
                    <h2>Введите поисковый запрос</h2>
                    <input type="text" value={searchTerm} onChange={(e) => {setSearchTerm(e.target.value)}} placeholder='ФИО, email, тип учётной записи, регион...' />
                    {loading ? (
                        <Loading />
                    ) 
                    : 
                    (searchTerm=='' ? (
                        <>
                            <a className={stylesSearch.warningLine} style={{textAlign: 'center', height: '100px', display: 'flex', justifyContent: 'center', alignItems: 'center'}}>Введите поисковый запрос</a>
                        </>
                    ) : (
                        <>
                            {warning ? ( 
                            <>
                                <a className={stylesSearch.warningLine} style={{textAlign: 'center', height: '100px', display: 'flex', justifyContent: 'center', alignItems: 'center'}}>{warning}</a>
                            </>
                            ) : (
                                <>
                                    <h2>Результаты поиска:</h2>
                                    <a style={{color: 'rgb(158, 158, 158)', margin: '0px', fontSize: '13px'}}>Первые 10 совпадений</a>
                                    <div className={stylesSearch.header}>
                                        <a className={stylesSearch.number}>ФИО</a>
                                        <a className={stylesSearch.applicant}>Email</a>
                                        <a className={stylesSearch.worker}>Тип уч.записи</a>
                                        <a className={stylesSearch.status}>Статус</a>
                                    </div>
                                    {users.map(user => (
                                        <motion.div
                                            key={user.id}
                                            initial={{ scale: '97%', opacity: 0 }}
                                            animate={{ scale: '100%', opacity: 1 }}
                                            exit={{ scale: '97%', opacity: 0 }}
                                            transition={{ duration: 0.3 }}
                                            layout
                                        >
                                            <Link to={`/user/${user.id}`} className={stylesSearch.case} onClick={(e) => {e.preventDefault(); window.open(`/user/${user.id}`, '_blank');}}>
                                                <a className={stylesSearch.number}>{user.lastname} {user.firstname} {user.surname}</a>
                                                <a className={stylesSearch.applicant}>{user.email || '-'}</a>
                                                <a className={stylesSearch.worker}>{user.role}</a>
                                                <a className={stylesSearch.status} style={{borderRight: 'none'}}>{user.approval}</a>
                                            </Link>
                                        </motion.div>
                                    ))}
                                </>
                            )}
                        </>
                    )
                    )}
                </div>
            </form>
        </div>
    );
};

export default SearchUsers;
